import React, { useEffect, useState } from 'react';
import { Button } from '@cimpress/react-components';
import { getI18nInstance } from '../i18n';
import { getTemplate } from '../apis/stereotype.api';
export const TemplateModifyButton = (props) => {
    const [template, setTemplate] = useState(null);
    const [fetching, setFetching] = useState(false);
    const [fetchingError, setFetchingError] = useState(null);
    const t = getI18nInstance().getFixedT(props.language);
    useEffect(() => {
        if (props.accessToken && props.templateUrl) {
            setFetching(true);
            getTemplate(props.accessToken, props.templateUrl)
                .then(template => {
                setFetching(false);
                setTemplate(template);
            })
                .catch(error => {
                setFetching(false);
                setFetchingError(error);
                if (props.onError) {
                    props.onError(error);
                }
            });
        }
    }, [props.templateUrl, props.accessToken]);
    return React.createElement(React.Fragment, null,
        React.createElement(Button, { href: "https://templatedesigner.cimpress.io/designer/" + encodeURIComponent((template || {}).templateId), target: '_blank', type: props.type || 'default', disabled: !props.templateUrl || fetching }, fetching
            ? t('loading')
            : t('modify-template-modal-button')));
};
//# sourceMappingURL=TemplateModifyButton.js.map